export const isConstantSourceNode = (audioNode) => {
    return 'offset' in audioNode;
};
//# sourceMappingURL=constant-source-node.js.map